// Serialize subscription mutations so an older location cannot overwrite a newer one.
export function createPushLifecycle({ base = '/api', fetchImpl = fetch } = {}) {
  let tail = Promise.resolve();
  const enqueue = task => { const job = tail.then(task); tail = job.catch(() => {}); return job; };
  const send = async (method, body) => {
    const response = await fetchImpl(`${base}/push/subscribe`, {
      method, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), signal: AbortSignal.timeout(10000),
    });
    if (!response.ok) throw new Error('Notifications could not be saved. Check your connection and retry.');
  };
  return {
    register(subscription, observer, activity) {
      return enqueue(async () => {
        if (!observer) throw new Error('Set your observing location before enabling notifications.');
        await send('POST', { subscription: subscription.toJSON(), lat: observer.lat, lon: observer.lon,
          name: observer.name, activity: activity || 'iss', minScore: 60 });
        return subscription.endpoint;
      });
    },
    remove(subscription) {
      return enqueue(async () => {
        await send('DELETE', { endpoint: subscription.endpoint, auth: subscription.toJSON().keys.auth });
        if (!await subscription.unsubscribe()) throw new Error('Your browser could not remove notifications. Retry.');
      });
    },
  };
}
